export * from './delete-fond.service';
export * from './delete-fond.service.module';